import '../../scss/pages/gallery.scss';

import lightGallery from 'lightgallery';
// Plugins
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'


let galleryPA=document.querySelectorAll('.lightgalleryPA');
let galleryKI=document.querySelectorAll('.lightgalleryKI');
let galleryPO=document.querySelectorAll('.lightgalleryPO');
let galleryDE=document.querySelectorAll('.lightgalleryDE');
let galleryST=document.querySelectorAll('.lightgalleryST');

window.onload = function() {
    for(var i = 1; i<=galleryPA.length; i++) {
        lightGallery(document.getElementById('lightgalleryPA'+ i), {
            plugins: [lgThumbnail],
            licenseKey: 'your_license_key',
            speed: 500,
            thumbnail: true,
            download: false,
            mobileSettings: {
                showCloseIcon: true,
                download: false
            },
        });
    }

    for(var i = 1; i<=galleryKI.length; i++) {
        lightGallery(document.getElementById('lightgalleryKI'+ i), {
            plugins: [lgThumbnail],
            licenseKey: 'your_license_key',
            speed: 500,
            thumbnail: true,
            download: false,
            mobileSettings: {
                showCloseIcon: true,
                download: false
            },
        });
    }

    for(var i = 1; i<=galleryPO.length; i++) {
        lightGallery(document.getElementById('lightgalleryPO'+ i), {
            plugins: [lgThumbnail],
            licenseKey: 'your_license_key',
            speed: 500,
            thumbnail: true,
            download: false,
            mobileSettings: {
                showCloseIcon: true,
                download: false
            },
        });
    }

    for(var i = 1; i<=galleryDE.length; i++) {
        lightGallery(document.getElementById('lightgalleryDE'+ i), {
            plugins: [lgThumbnail],
            licenseKey: 'your_license_key',
            speed: 500,
            thumbnail: true,
            download: false,
            mobileSettings: {
                showCloseIcon: true,
                download: false
            },
        });
    }

    for(var i = 1; i<=galleryST.length; i++) {
        lightGallery(document.getElementById('lightgalleryST'+ i), {
            plugins: [lgThumbnail],
            licenseKey: 'your_license_key',
            speed: 500,
            thumbnail: true,
            download: false,
            mobileSettings: {
                showCloseIcon: true,
                download: false
            },
        });
    }
}